import { db, auth, provider, timestamp } from "../../firebase";
import {
  SET_USER,
  SHOW_LOGIN_MODAL,
  RESET_PASSWORD_SUCCESS,
} from "./actionType";
import {
  addNewProfile,
  addProfile,
  setProfile,
  getProfile,
  getProfileDocId,
  updateProfile,
  addProfileContacts,
} from "./profileAction";

import {
  collection,
  query,
  where,
  limit,
  getDocs,
} from "firebase/firestore";

import {
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";

export const setUser = (payload) => ({
  type: SET_USER,
  user: payload,
});

export function signInAPI() {
  return async (dispatch) => {
    try {
      const result = await signInWithPopup(auth, provider);
      dispatch(hideLoginModal());
      dispatch(setUser(result.user));
      const docId = await getProfileDocId(result.user);
      if (docId) {
        dispatch(getProfile(result.user));
      } else {
        dispatch(addProfile(result.user));
      }
    } catch (error) {
      alert(error.message);
    }
  };
}

export function signInEmailAPI(fullname, email, password, gender, dob, mobile) {
  return async (dispatch) => {
    try {
      const userCredentials = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredentials.user;
      const dobDate = new Date(dob);
      dispatch(hideLoginModal());
      await addNewProfile(user);
      const docId = await getProfileDocId(user);
      dispatch(addProfileContacts(user.uid, "", email, mobile));
      dispatch(
        updateProfile(user, { docId }, {
          uid: user.uid,
          full_name: fullname,
          email,
          gender,
          dob: dobDate,
          mobile,
          reg_date: timestamp
        })
      );
    } catch (error) {
      alert(error.message);
    }
  };
}

export function sendPasswordResetEmailAction(email) {
  return async (dispatch) => {
    try {
      await sendPasswordResetEmail(auth, email);
      dispatch(resetPasswordStatus(true));
    } catch (err) {
      alert(err.message);
    }
  };
}

export const resetPasswordStatus = (restPwdStatus) => ({
  type: RESET_PASSWORD_SUCCESS,
  restPwdStatus,
});

export function loginWithEmailAndPasswordAction(email, password) {
  return async (dispatch) => {
    try {
      const userCredentials = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredentials.user;
      dispatch(setUser(user));
      const docId = await getProfileDocId(user);
      if (docId) {
        dispatch(getProfile(user));
      } else {
        dispatch(addProfile(user));
      }
      dispatch(hideLoginModal());
    } catch (error) {
      alert(error.message);
    }
  };
}

export function signOutAPI() {
  return async (dispatch) => {
    try {
      await signOut(auth);
      dispatch(setUser(null));
      dispatch(setProfile(null));
    } catch (error) {
      alert(error.message);
    }
  };
}

export function getUserAuth() {
  return (dispatch) => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        dispatch(setUser(user));
        dispatch(getProfile(user));
      }
    });
  };
}

export function loginWithVnkId(vnkId, password) {
  return async (dispatch) => {
    try {
      const usernameLookupRef = collection(db, "username_lookup");
      const q = query(usernameLookupRef, where("userName", "==", vnkId), limit(1));
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        const userLookup = querySnapshot.docs[0].data();
        dispatch(loginWithEmailAndPasswordAction(userLookup.email, password));
      } else {
        alert("VNK ID not found, Please check your ID.");
      }
    } catch (error) {
      alert(error.message);
    }
  };
}

export const showLoginModal = () => ({
  type: SHOW_LOGIN_MODAL,
  show: true,
});

export const hideLoginModal = () => ({
  type: SHOW_LOGIN_MODAL,
  show: false,
});
